var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransmit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5v-.6a.6.6 0 00-.6.6h.6zm0 6H.9a.6.6 0 00.6.6V11zM8 11h.6a.6.6 0 00-.6-.6v.6zm0 3h-.6a.6.6 0 001.007.44L8 14zm6.5-6l.407.44a.6.6 0 000-.88L14.5 8zM8 2l.407-.44A.6.6 0 007.4 2H8zm0 3v.6a.6.6 0 00.6-.6H8zM.9 5v6h1.2V5H.9zm.6 6.6H8v-1.2H1.5v1.2zm5.9-.6v3h1.2v-3H7.4zm1.007 3.44l6.5-6-.814-.88-6.5 6 .814.88zm6.5-6.88l-6.5-6-.814.88 6.5 6 .814-.88zM7.4 2v3h1.2V2H7.4zM8 4.4H1.5v1.2H8V4.4z",
    fill: "#7D8085"
  })));
}
export default __webpack_public_path__ + "static/transmit.11ed9a02.svg";
export { SvgTransmit as ReactComponent };